<template>
  <div v-if="showSuccess">
    <div class="success-message alert alert-success">
      {{ $t("aequitex_interest") }}
      {{ $t("aequitex_email_info_collectively_by_two") }}
      {{ $t("aequitex_activation_note_collectively_by_two") }}
      {{ $t("aequitex_contact") }}
    </div>
  </div>

  <div v-else-if="!documentSigned" class="skribble-form-poa-collectively-by-two card p-4">
    <div>
      <h2 class="mb-3 text-center">{{ $t('skr_form_poa_two_title') }}</h2>
      <p class="mb-0">
        {{ $t('skr_two_signatories') }}
      </p>

      <form v-if="form" @submit.prevent="sendForSigning">
      <!-- Administrator (Grantor) -->
      <h4 v-if="!isFromDebtor"  class="mt-3 mb-1">
        <span class="font-weight-bold">{{ $t('skr_admin_section') }}</span>
        <span class="font-weight-light font-italic">{{ $t('skr_admin_section_end') }}</span>
      </h4>
      <div v-if="!isFromDebtor" class="form-row">
        <div class="form-group col-4">
          <label>{{ $t('skr_admin_salutation') }} <span class="red-asterisk">*</span></label>
          <select v-model="form.admin_salutation" class="form-control" :class="{ 'is-invalid': invalidFields['admin_salutation'] }" ref="admin_salutation">
            <option value="" disabled selected>{{ $t('please_select') }}</option>
            <option value="mr">{{ $t('mr') }}</option>
            <option value="mrs">{{ $t('mrs') }}</option>
          </select>
        </div>
        <div class="form-group col-4">
          <label>{{ $t('first_name') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.admin_first" class="form-control" :class="{ 'is-invalid': invalidFields['admin_first'] }" ref="admin_first"/>
        </div>
        <div class="form-group col-4">
          <label>{{ $t('last_name') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.admin_last" class="form-control" :class="{ 'is-invalid': invalidFields['admin_last'] }" ref="admin_last"/>
        </div>
      </div>
      <div v-if="!isFromDebtor" class="form-row">
        <div class="form-group col-12">
          <label>{{ $t('skr_admin_address') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.admin_address" class="form-control" :class="{ 'is-invalid': invalidFields['admin_address'] }" ref="admin_address"/>
        </div>
      </div>
      <div v-if="!isFromDebtor" class="form-row">
        <div class="form-group col-4">
          <label>{{ $t('skr_admin_zip') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.admin_zip" class="form-control" :class="{ 'is-invalid': invalidFields['admin_zip'] }" ref="admin_zip"/>
        </div>
        <div class="form-group col-4">
          <label>{{ $t('city') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.admin_city" class="form-control" :class="{ 'is-invalid': invalidFields['admin_city'] }" ref="admin_city"/>
        </div>
        <div class="form-group col-4">
          <label>{{ $t('country_name') }} <span class="red-asterisk">*</span></label>
          <select v-model="form.admin_country" class="form-control" :class="{ 'is-invalid': invalidFields['admin_country'] }" ref="admin_country">
            <option value="" disabled selected>{{ $t('please_select') }} {{ $t('country_name') }}</option>
            <option
                v-for="country in countryOptions"
                :key="country.id"
                :value="country.name">
              {{ country.name }}
            </option>
          </select>
        </div>
      </div>

      <!-- Signatory 1 -->
      <h4 class="mt-3 mb-1">{{ $t('skr_signatory1_section') }}</h4>
      <div class="form-row">
        <div class="form-group col-4">
          <label>{{ $t('skr_signatory_salutation') }} <span class="red-asterisk">*</span></label>
          <select v-model="form.sign_salutation" class="form-control" :class="{ 'is-invalid': invalidFields['sign_salutation'] }" ref="sign_salutation">
            <option value="" disabled selected>{{ $t('please_select') }}</option>
            <option value="mr">{{ $t('mr') }}</option>
            <option value="mrs">{{ $t('mrs') }}</option>
          </select>
        </div>
        <div class="form-group col-4">
          <label>{{ $t('first_name') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.sign_first" class="form-control" :class="{ 'is-invalid': invalidFields['sign_first'] }" ref="sign_first"/>
        </div>
        <div class="form-group col-4">
          <label>{{ $t('last_name') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.sign_last" class="form-control" :class="{ 'is-invalid': invalidFields['sign_last'] }" ref="sign_last"/>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-12">
          <label>{{ $t('skr_signatory_address') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.sign_address" class="form-control" :class="{ 'is-invalid': invalidFields['sign_address'] }" ref="sign_address"/>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-4">
          <label>{{ $t('skr_signatory_zip') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.sign_zip" class="form-control" :class="{ 'is-invalid': invalidFields['sign_zip'] }" ref="sign_zip"/>
        </div>
        <div class="form-group col-4">
          <label>{{ $t('city') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.sign_city" class="form-control" :class="{ 'is-invalid': invalidFields['sign_city'] }" ref="sign_city"/>
        </div>
        <div class="form-group col-4">
          <label>{{ $t('country_name') }} <span class="red-asterisk">*</span></label>
          <select v-model="form.sign_country" class="form-control" :class="{ 'is-invalid': invalidFields['sign_country'] }" ref="sign_country">
            <option value="" disabled selected>{{ $t('please_select') }} {{ $t('country_name') }}</option>
            <option
                v-for="country in countryOptions"
                :key="country.id"
                :value="country.name">
              {{ country.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-6">
          <label>{{ $t('skr_signatory_email') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.sign_email" type="email" class="form-control" :class="{ 'is-invalid': invalidFields['sign_email'] }" ref="sign_email"/>
        </div>
        <div class="form-group col-6">
          <label>{{ $t('mobile') }} <span class="red-asterisk">*</span></label>
          <validation-provider
              ref="phoneValidator"
              #default="{ errors }"
              name="phoneValidation"
              rules="required"
          >
            <b-input-group>
              <b-input-group-prepend id="phoneCountries">
                <b-form-select
                    v-model.trim="form.sign_phone_code"
                    :options="countries"
                />
              </b-input-group-prepend>

              <b-form-input
                  id="sign-mobile"
                  v-model.trim="form.sign_mobile"
                  class="form-control"
                  :state="errors.length > 0 ? false : null"
                  :class="{ 'is-invalid': invalidFields['sign_mobile'] }"
                  ref="sign_mobile"
                  @input="checkPhoneFormat"
              />
            </b-input-group>

            <small class="text-danger">{{ $t(errors[0]) }}</small>
            <small
                v-if="phoneValidation"
                class="text-danger"
            >{{ phoneValidation }}
            </small>
          </validation-provider>
        </div>
      </div>

      <!-- Signatory 2 -->
      <h4 class="mt-3 mb-1">{{ $t('skr_signatory2_section') }}</h4>
      <div class="form-row">
        <div class="form-group col-4">
          <label>{{ $t('skr_signatory_salutation') }} <span class="red-asterisk">*</span></label>
          <select v-model="form.sign_salutation_second" class="form-control" :class="{ 'is-invalid': invalidFields['sign_salutation_second'] }" ref="sign_salutation_second">
            <option value="" disabled selected>{{ $t('please_select') }}</option>
            <option value="mr">{{ $t('mr') }}</option>
            <option value="mrs">{{ $t('mrs') }}</option>
          </select>
        </div>
        <div class="form-group col-4">
          <label>{{ $t('first_name') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.sign_first_second" class="form-control" :class="{ 'is-invalid': invalidFields['sign_first_second'] }" ref="sign_first_second"/>
        </div>
        <div class="form-group col-4">
          <label>{{ $t('last_name') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.sign_last_second" class="form-control" :class="{ 'is-invalid': invalidFields['sign_last_second'] }" ref="sign_last_second"/>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-12">
          <label>{{ $t('skr_signatory_address') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.sign_address_second" class="form-control" :class="{ 'is-invalid': invalidFields['sign_address_second'] }" ref="sign_address_second"/>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-4">
          <label>{{ $t('skr_signatory_zip') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.sign_zip_second" class="form-control" :class="{ 'is-invalid': invalidFields['sign_zip_second'] }" ref="sign_zip_second"/>
        </div>
        <div class="form-group col-4">
          <label>{{ $t('city') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.sign_city_second" class="form-control" :class="{ 'is-invalid': invalidFields['sign_city_second'] }" ref="sign_city_second"/>
        </div>
        <div class="form-group col-4">
          <label>{{ $t('country_name') }} <span class="red-asterisk">*</span></label>
          <select v-model="form.sign_country_second" class="form-control" :class="{ 'is-invalid': invalidFields['sign_country_second'] }" ref="sign_country_second">
            <option value="" disabled selected>{{ $t('please_select') }} {{ $t('country_name') }}</option>
            <option
                v-for="country in countryOptions"
                :key="country.id"
                :value="country.name">
              {{ country.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-6">
          <label>{{ $t('skr_signatory_email') }} <span class="red-asterisk">*</span></label>
          <input v-model="form.sign_email_second" type="email" class="form-control" :class="{ 'is-invalid': invalidFields['sign_email_second'] }" ref="sign_email_second"/>
        </div>
        <div class="form-group col-6">
          <label>{{ $t('mobile') }} <span class="red-asterisk">*</span></label>
          <validation-provider
              ref="phoneValidatorSecond"
              #default="{ errors }"
              name="phoneValidationSecond"
              rules="required"
          >
            <b-input-group>
              <b-input-group-prepend id="phoneCountriesSecond">
                <b-form-select
                    v-model.trim="form.sign_phone_code_second"
                    :options="countries"
                />
              </b-input-group-prepend>

              <b-form-input
                  id="sign-mobile-second"
                  v-model.trim="form.sign_mobile_second"
                  class="form-control"
                  :state="errors.length > 0 ? false : null"
                  :class="{ 'is-invalid': invalidFields['sign_mobile_second'] }"
                  ref="sign_mobile_second"
                  @input="checkPhoneFormatSecond"
              />
            </b-input-group>

            <small class="text-danger">{{ $t(errors[0]) }}</small>
            <small
                v-if="phoneValidationSecond"
                class="text-danger"
            >{{ phoneValidationSecond }}
            </small>
          </validation-provider>
        </div>
      </div>

      <!-- Company -->
      <br>
      <br>
      <div class="form-group">
        <label>{{ $t('skr_company_name') }} <span class="red-asterisk">*</span></label>
        <input v-model="form.company_name" class="form-control"  :class="{ 'is-invalid': invalidFields['company_name'] }" ref="company_name"/>
      </div>
      <div class="form-row">
        <div class="form-group col-12">
          <label>{{ $t('skr_company_address') }}</label>
          <input v-model="form.company_address" class="form-control" :class="{ 'is-invalid': invalidFields['company_address'] }" ref="company_address"/>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-4">
          <label>{{ $t('skr_company_zip') }}</label>
          <input v-model="form.company_zip" class="form-control" :class="{ 'is-invalid': invalidFields['company_zip'] }" ref="company_zip"/>
        </div>
        <div class="form-group col-4">
          <label>{{ $t('city') }}</label>
          <input v-model="form.company_city" class="form-control" :class="{ 'is-invalid': invalidFields['company_city'] }" ref="company_city"/>
        </div>
        <div class="form-group col-4">
          <label>{{ $t('country_name') }}</label>
          <select v-model="form.company_country" class="form-control" :class="{ 'is-invalid': invalidFields['company_country'] }" ref="company_country">
            <option value="" disabled selected>{{ $t('please_select') }} {{ $t('country_name') }}</option>
            <option v-for="country in countryOptions" :key="country.id" :value="country.name">{{ country.name }}</option>
          </select>
        </div>
      </div>

      <!-- Submit -->
      <div class="mt-3 text-right">
        <button :disabled="loading" class="btn btn-primary">
          <span v-if="loading">
            <img width="50" height="50" src="/new-loader.svg" alt="loader"/>
          </span>
          <span v-else>
            {{ $t('skr_btn') }}
          </span>
        </button>
        <div v-if="error" class="alert text-danger mt-1">{{ $t(error) }}</div>
      </div>
    </form>

      <SkribblePopup
          :show="showPopup"
          @cancel="showPopup = false"
          @continue="handlePopupConfirm"
      />
    </div>
  </div>

  <div v-else class="p-4 text-center">
    <h3 class="text-success text-large">{{ $t('skr_document_signed') }}</h3>
  </div>
</template>

<script>
import {BFormInput, BFormSelect, BInputGroup, BInputGroupPrepend} from "bootstrap-vue";
import {ValidationProvider} from "vee-validate";
import {phone} from "phone";

export default {
  name: "SkribbleFormPOACollectivelyByTwo",
  components: {ValidationProvider, BInputGroup, BFormSelect, BFormInput, BInputGroupPrepend},
  props: {
    isFromDebtor: false,
    debtorData: null,
  },
  data() {
    return {
      form: {},
      error: null,
      errorSecond: null,
      debtor: null,
      country: '',
      countries: [],
      loading: false,
      showPopup: false,
      invalidFields: {},
      showSuccess: false,
      countryOptions: [],
      documentSigned: false,
      pollInterval: null,
      disabledButton: false,
      signatoryEmail: "",
      phoneValidation: '',
      phoneValidationSecond: '',
      secondSignatoryEmail: "",
      pollIntervalUserCheck: null,
      formType: '',
    };
  },

  async created() {
    const user = await this.refreshUser();
    const company = user?.company || {};

    if (this.isFromDebtor) {
      this.formType = this.debtorData.form_type ? this.debtorData.form_type : "debt_ack_non_recourse";
    } else {
      this.formType = 'power_of_attorney_collectively_by_two'
    }

    if (!user && this.isFromDebtor) {
      await this.fetchMinimalDebtor()
    } else {
      await this.getSignatories(user.id);
    }

    this.fetchCountries();
    this.checkSigningStatus()

    if (company?.country_id) {
      await this.getCountryName(company.country_id);
    }

    if (user) {
      this.form = {
        admin_salutation: user.gender == 0 ? "mr" : (user.gender == 1 ? "mrs" : ""),
        admin_first: user.first_name || "",
        admin_last: user.last_name || "",
        admin_address: user.address || "",
        admin_zip: user.zip || "",
        admin_city: user.city || "",
        admin_email: user.email || "",
        admin_country: user.country.name || "",

        sign_salutation: user.gender == 0 ? "mr" : (user.gender == 1 ? "mrs" : ""),
        sign_first: user.first_name || "",
        sign_last: user.last_name || "",
        sign_address: user.address || "",
        sign_zip: user.zip || "",
        sign_city: user.city || "",
        sign_country: user.country.name || "",
        sign_email: user.email  || "",
        sign_mobile: user.phone || "",
        sign_phone_code: user.iso_code ?? 'CH',

        sign_salutation_second: "",
        sign_first_second: "",
        sign_last_second: "",
        sign_address_second: "",
        sign_zip_second: "",
        sign_city_second: "",
        sign_country_second: "",
        sign_email_second: "",
        sign_phone_code_second: "CH",

        company_name: company.name || "",
        company_address: (company.address || "") + ' ' + (company.address_nr || "") ,
        company_zip: company.zip || "",
        company_city: company.city || "",
        company_country: this.country || ""
      };
    } else {
      this.form = {
        admin_salutation: "",
        admin_first: "",
        admin_last: "",
        admin_email: "",

        sign_salutation: this.debtor.gender == 0 ? "mr" : (this.debtor.gender == 1 ? "mrs" : ""),
        sign_first: this.debtor.first_name || "",
        sign_last: this.debtor.last_name || "",
        sign_email: this.debtor.email || "",
        sign_mobile: "",
        sign_phone_code: "CH",

        sign_salutation_second: "",
        sign_first_second: "",
        sign_last_second: "",
        sign_address_second: "",
        sign_zip_second: "",
        sign_city_second: "",
        sign_country_second: "",
        sign_email_second: "",
        sign_mobile_second: "",
        sign_phone_code_second: "CH",

        company_name: this.debtorData.debtor_company_name || "",
        company_address: this.debtorData.debtor_address_street || "",
        company_zip: this.debtorData.debtor_address_zip || "",
        company_city: this.debtorData.debtor_address_city || "",
        company_country: this.debtorData.debtor_address_country || "",
      };
    }

    this.loadCountriesForPhone();
  },

  methods: {
    loadCountriesForPhone() {
      this.$http.post('/countries').then(res => {
        res.data.value.map(item => {
          this.countries.push({
            value: item.iso_code,
            text: `${item.iso_code} (${item.phone_code})`,
          })
        })
      })
    },

    checkPhoneFormat() {
      const validation = phone(this.form.sign_mobile, {
        country: this.form.sign_phone_code,
        validateMobilePrefix: false,
      })

      if (validation && validation.isValid == false) {
        this.phoneValidation = `Phone for ${this.form.sign_phone_code} must be valid`
      } else {
        this.phoneValidation = ''
      }
    },

    checkPhoneFormatSecond() {
      const validation = phone(this.form.sign_mobile_second, {
        country: this.form.sign_phone_code_second,
        validateMobilePrefix: false,
      })

      if (validation && validation.isValid == false) {
        this.phoneValidationSecond = `Phone for ${this.form.sign_phone_code_second} must be valid`
      } else {
        this.phoneValidationSecond = ''
      }
    },

    async refreshUser() {
      try {
        let user = this.$store.state.auth.user;
        if ( user ) {
          const { data } = await this.$http.post(`/getUserDataWithId/${user.id}`);

          if (data && data.value) {
            this.$store.commit("auth/SET_USER", data.value);
            return data.value;
          } else {
            console.warn("No user returned from backend");
            return user;
          }
        }
      } catch (err) {
        console.error("Failed to refresh user:", err);
        return this.$store.state.auth.user;
      }
    },

    async fetchMinimalDebtor() {
      try {
        let debtor_id = this.debtorData?.debtor_company_id;
        let seller_id = this.debtorData?.seller_company_id;
        if (!debtor_id) return null;

        const res = await this.$http.post('/getDebtorMinimalData', { debtor_id , seller_id});
        if (res.data?.value) {
          this.debtor = res.data.value;
          return this.debtor;
        }
        return null;
      } catch (err) {
        console.error("Failed to fetch debtor:", err);
        return null;
      }
    },

    async sendForSigning() {
      this.error = null;
      this.invalidFields = {};

      let required = [
        "sign_salutation", "sign_first", "sign_last", "sign_address", "sign_zip", "sign_city", "sign_country", "sign_email", "sign_mobile",
        "sign_salutation_second", "sign_first_second", "sign_last_second", "sign_address_second", "sign_zip_second", "sign_city_second", "sign_country_second", "sign_email_second", "sign_mobile_second",
        "company_name", "company_address", "company_zip", "company_city", "company_country"
      ];

      if (!this.isFromDebtor) {
        required = [
          "admin_salutation", "admin_first", "admin_last", "admin_address", "admin_zip", "admin_city",
          ...required
        ];
      }

      required.forEach(field => {
        if (!this.form[field]) this.invalidFields[field] = true;
      });

      if (Object.keys(this.invalidFields).length) {
        this.error = this.$t("skr_error_fill_required");
        const firstInvalidField = Object.keys(this.invalidFields)[0];
        const el = this.$refs[firstInvalidField];
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          if (el.focus) el.focus();
        }
        return;
      }

      this.loading = true;
      try {
        if (this.isFromDebtor) {
          const signFields = [ "salutation", "first", "last", "email", "zip", "city", "address", "country", 'mobile', 'phone_code' ];

          signFields.forEach(field => {
            this.debtorData[`sign_${field}`] = this.form[`sign_${field}`];
            this.debtorData[`sign_${field}_second`] = this.form[`sign_${field}_second`];
          });

          const res = await this.$http.post('/skribble/debt-acknowledgement/generate-debtor-pdf', this.debtorData);
          this.pdfUrl = res.data.value.pdf_url;

          if (this.pdfUrl) {
            this.handleButtonClick()
          }
        } else {
          const payload = {
            form: this.form,
            is_from_debtor: this.isFromDebtor,
            form_type: this.formType,
            lang: this.$i18n.locale
          };
          const res = await this.$http.post("/skribble/power-of-attorney/generate", payload);
          const signingUrl = res?.data?.value?.signing_url;

          if (!signingUrl) {
            this.error = "Internal server error";
          } else if (signingUrl) {
            // save the main contact person with calling parent method
            this.$emit("save-requested");
            this.documentSigned = true;
            this.showSuccess = true;
          }
        }
      } catch (err) {
        console.error(err);
        this.error = err.response?.data?.message || err.message || "Something went wrong.";
      } finally {
        this.loading = false;
      }
    },

    handlePopupConfirm() {
      this.showPopup = false;
      this.openSigningUrl();
    },

    handleButtonClick() {
      if (localStorage.getItem("hideSkribblePopup") === "true") {
        this.openSigningUrl();
      } else {
        this.showPopup = true;
      }
    },

    openSigningUrl() {
      let form_type = "debt_ack_non_recourse";
      this.$http.post('/skribble/debt-acknowledgement/send-for-signing', this.debtorData).then((res) => {
        this.signingUrl = res.data.value.signing_url ?? null;

        if (this.signingUrl) {
          window.open(this.signingUrl, "_blank");
          this.showSuccess = true;
          this.pollInterval = setInterval(() => {
            this.checkSigningStatus(form_type)
          }, 10000);
        }
      })
    },

    async getSignatories(userId) {
      try {
        const res = await this.$http.post(`/skribble/power-of-attorney/${userId}/${this.formType}`);

        let emails = res?.data?.value?.emails;

        if (!Array.isArray(emails)) {
          try {
            emails = JSON.parse(emails);
          } catch (err) {
            console.error("Failed to parse emails JSON:", err);
            emails = [];
          }
        }

        if (Array.isArray(emails) && emails.length > 0) {
          this.signatoryEmail = emails[0] || "";
          this.secondSignatoryEmail = emails[1] || "";
        }
      } catch (err) {
        console.error("Failed to fetch second signatory email", err);
      }
    },

    checkSigningStatus() {
      let invoice_id = null;
      let user = this.$store.state.auth.user ?? null;
      if (this.isFromDebtor && this.debtorData) {
        invoice_id = this.debtorData.invoice_id ? this.debtorData.invoice_id : null
      }

      let payload = {
        invoice_id
      }

      let endpoint = '';

      if (this.debtorData) {
          endpoint = `/skribble/check-status/${this.debtorData.debtor_company_id}/${this.formType}`;
          payload.is_company = true
      }else {
        endpoint = `/skribble/check-status/${user.id}/${this.formType}`;
      }

      this.$http.post(endpoint, payload)
      .then((res) => {
        if (res.data?.value === "SIGNED") {
          clearInterval(this.pollInterval);
          this.pollInterval = null;
          this.documentSigned = true;
          this.showSuccess = true;
        } else if (res.data?.value === "PENDING" || res.data?.value === "UPDATED") {
          this.showSuccess = true;
        }
      })
      .catch((err) => {
        console.error("Error checking signing status", err);
      });
    },

    fetchCountries() {
      this.$http.post('/countries').then(res => {
        const countries = res.data.value || [];
        const uniqueCountries = countries.filter(
            (country, index, self) => index === self.findIndex(c => c.id === country.id)
        );
        this.countryOptions = uniqueCountries;
      });
    },

    async getCountryName(countryId) {
      if (!countryId) return '';
      const res = await this.$http.post(`countries/${countryId}`);
      this.country = res?.data?.value?.name || '';
    },

  }
};
</script>

<style scoped>
.skribble-form-poa-collectively-by-two {
  max-width: 980px;
  margin: 0 auto;
  background: #e1e1e12e;
}
.success-message {
  max-width: 1050px;
  margin: 0 auto;
  font-size: 16px;
  padding: 25px;
}
.is-invalid {
  border: 1px solid red !important;
}
.red-asterisk {
  color: red;
}
label {
  font-size: 13px;
}
</style>
